import { FormattedMessage } from "react-intl";

import { Button } from "@/components/atoms/Button";
import { Text } from "@/components/atoms/Text";
import { buildSimilarSpacesUrl } from "~/components/listings/utils";
import { useListingData } from "~/context/ListingPageDataContext";

export const BookListingCardUnavailable = () => {
  const { data: listingData } = useListingData();

  const similarSpacesUrl = buildSimilarSpacesUrl({
    city: listingData.listingCity,
    state: listingData.listingState,
    useType: listingData.useType,
  });

  return (
    <div className="tw-border tw-border-gray-200 tw-rounded-4 tw-p-24 tw-hidden lg:tw-block">
      <Text
        typeface="body-1"
        className="tw-text-gray-600 tw-text-center tw-mb-24"
      >
        <FormattedMessage defaultMessage="This space is currently unavailable for booking" />
      </Text>
      <Button appearance="purple" className="tw-w-full" href={similarSpacesUrl}>
        <FormattedMessage defaultMessage="Browse similar spaces" />
      </Button>
    </div>
  );
};
